import { render, staticRenderFns } from "./TheUserRequests.vue?vue&type=template&id=621603f1&"
import script from "./TheUserRequests.vue?vue&type=script&lang=js&"
export * from "./TheUserRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports